import { useEffect, useState } from "react";
import IosApp from "./IosApp";
import AndroidApp from "./AndroidApp";
import Close from "../../../../Assets/close.svg";
import { Container, Modal } from "react-bootstrap";
import { useCreateApp } from "../../../../hooks/DevAppHooks";
import createNewAppIcon from "../../../../Assets/projectlifecycle/createNewAppIcon.svg";
import styles from "./styles.module.scss";
import ConsoleLocalStorage from "../../../../storage/storage";

const appType = [
  { key: "3D Application", value: "3D" },
  // { key: "2D Application", value: "2D", },
  // { key: "Web Application", value: "pwa"},
];

const NewAppModal = ({
  showNewAppModal,
  setShowNewAppModal,
  projectid,
  configData,
}) => {
  const handleClose = () => setShowNewAppModal(false);
  const [currentOs, setCurrentOs] = useState("android");
  const [org, setOrg] = useState({});
  useEffect(() => {
    setOrg(ConsoleLocalStorage.getOrganization());
  }, []);
  const { mutate } = useCreateApp(projectid, setShowNewAppModal);

  const onSubmit = (values) => {
    const { platform } = values;
    // const finalObj = {
    //   ...values,
    //   platform: platform[0], // TODO: after api fixed change it from platform[0] into platform
    //   appOS: currentOs,
    //   tags: [org && org.tags ? org.tags.toLowerCase() : "consumer"],
    // };

    const finalObjNewSchema = {
      ...values,
      appOS: currentOs,
      platform: platform,
      tags: [org && org.tags ? org.tags.toLowerCase() : "consumer"],
    };
    // delete finalObjNewSchema.platform;

    // if (finalObj.appOS === "ios") {
    //   finalObj.packageName = finalObj.bundleID;
    //   delete finalObj.bundleID;
    // }

    if (finalObjNewSchema.appOS === "ios") {
      finalObjNewSchema.packageName = finalObjNewSchema.bundleID;
      delete finalObjNewSchema.bundleID;
    }
    mutate(finalObjNewSchema);
  };

  return (
    <>
      <Container>
        <Modal
          show={showNewAppModal}
          onHide={handleClose}
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <img
                  src={createNewAppIcon}
                  alt="logo"
                  style={{
                    width: "0.7em",
                    height: "0.7em",
                    marginRight: "0.25em",
                  }}
                />
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Create New App
                </span>
              </div>
            </Modal.Title>
            <img
              onClick={() => setShowNewAppModal(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <div className="form-wrapper">
              <div
                style={{ display: "flex", gap: "64px", marginBottom: "31px" }}
              >
                {configData?.osList?.map(
                  (el) =>
                    el.show && (
                      <button
                        style={{
                          width: "100%",
                          height: "65px",
                          background: "#1A1A1A",
                          border:
                            currentOs === el.id ? "1px solid white" : "none",
                          borderRadius: "10px",
                          color: "white",
                          fontFamily: "JioType-Medium",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() => setCurrentOs(el.id)}
                      >
                        <img src={el?.icon} alt={el.id} />
                        {el?.value}
                      </button>
                    )
                )}
              </div>
              {currentOs === "ios" ? (
                <IosApp
                  configData={configData}
                  appType={appType}
                  onSubmit={onSubmit}
                />
              ) : (
                <AndroidApp
                  configData={configData}
                  appType={appType}
                  onSubmit={onSubmit}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default NewAppModal;
